<template>
	<r-standard-modal-form @closeModal="closeModal">
		<span slot="title" class="version-history-modal-header">Version History (Beta)</span>
		<div slot="body" class="version-history-modal-body">			
			<version-history-item
				v-for="dataChange, index in dataChangesForDataStoreInReverseChronologicalOrder"
				:key="dataChange.$internals.metaProperties.meta.guid"
				:dataChange="dataChange"
			>				
			</version-history-item>
		</div>
	</r-standard-modal-form>
</template>

<script>


import VersionHistoryItem from 'vue/sheet-views/common/version-history/version-history-item.vue';

export default {
	$pubsub:{

	},
	data(){
		return {
			
		}
	},
	components:{
		VersionHistoryItem,
	},
	mounted(){
		this.dataStore.$internals.graphManager.loadEdges({
			inboundIncludes:[{
				filters:{
					meta:{
						type:{
							eq:"DataChange",
						}
					},
					edges:{
						name:{
							eq:"dataStore",
						}
					},					
				},
				linkedObjects:{
					depth: 1,
				},
				options:{
					limit: 50,
					edgeGroup: 'dataChangesLoaded',
					ordering:[{
						target: 'context',
						property: 'datetime',
						order: 'desc',
					}]
				}
			}]
		}, function withEdgesBack(){
			console.log("Back from load", arguments);
		})
	},
	props:{
		dataStore:{
			required: true,
			type: Object,
		},
	},
	computed:{
		dataChangesForDataStoreInReverseChronologicalOrder(){
			return this.dataStore.$internals.inboundEdges.object.DataChange.name.dataStore.map(function getFromObject(edge){
				return edge.from;
			}).sort(function sortByDateCreated(dataChangeA, dataChangeB){
				return dataChangeB.$internals.metaProperties.meta.dateCreated.getTime() - dataChangeA.$internals.metaProperties.meta.dateCreated.getTime();
			});
		}
	},
	methods:{
		closeModal(){
			this.$emit('closeModal');
		}	
	}
}

</script>

<style scoped lang="scss">

.version-history-modal-header{
	cursor: default;
}

.version-history-modal-body{

}


</style>